import React, { useState } from "react";
import { Modal, FormGroup, ControlLabel, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Spinner } from "../../Utils/Loaders";
import { conceptType } from "../../../variables/Enums";
import { SnomedPicker } from "../../CustomControls/SnomedPicker";

export const ModalCreateDevice = ({ show, onClose, onSave }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    device: null,
    name: "",
    serialNumber: "",
  });

  const [saving, setSaving] = useState(false);

  const handleInputChange = (e) => {
    if (!e?.target) {
      return;
    }
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    const { device, name, serialNumber } = formData;

    const payload = {
      device,
      name,
      serialNumber,
    };

    setSaving(true);

    onSave(payload, setSaving);
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      dialogClassName="rounded-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>{t("devices.createModal.title")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {saving && <Spinner />}
        {!saving && (
          <>
            <FormGroup controlId="formName">
              <ControlLabel>{t("devices.createModal.nameLabel")}</ControlLabel>
              <input
                id="name"
                name="name"
                className="form-control"
                value={formData.name || ""}
                onChange={handleInputChange}
              />
            </FormGroup>
            <FormGroup controlId="serialNumber">
              <ControlLabel>
                {t("devices.createModal.serialNumberLabel")}
              </ControlLabel>
              <input
                type="text"
                id="serialNumber"
                name="serialNumber"
                className="form-control"
                value={formData.serialNumber || ""}
                onChange={handleInputChange}
                autoComplete="off"
              />
            </FormGroup>
            <FormGroup controlId="formDevice">
              <ControlLabel>
                {t("devices.createModal.deviceLabel")}
              </ControlLabel>
              <SnomedPicker
                conceptType={conceptType.events}
                defaultSelected={formData.device ? [formData.device] : []}
                id="device"
                value={formData.device}
                name="device"
                placeholder={t("commons.search")}
                onChange={handleChange}
                // onBlur={setFieldTouched}
                conceptId={"272181003"}
              />
            </FormGroup>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={onClose}>
          {t("devices.createModal.cancelLabel")}
        </Button>
        {!saving && (
          <Button
            disabled={!formData.device || !formData.name}
            variant="btn btn-primary"
            onClick={handleSubmit}
          >
            {t("devices.createModal.acceptLabel")}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
